module.exports = __webpack_public_path__ + "static/img/product_warranty.098beea0.png";